// loadingMessages.js
export const MESSAGE_CATEGORIES = {
  aiInsights: "aiInsights",
  aiMagic: "aiMagic",
  feedback: "feedback",
  general: "general",
};

export const loadingMessages = {
  [MESSAGE_CATEGORIES.aiInsights]: [
    "Uncovering insights",
    "Highlighting brilliance",
    "Mapping progress",
    "Generating fruitful insights",
    "Insights loading",
    "Powering up insights",
  ],
  [MESSAGE_CATEGORIES.aiMagic]: [
    "Working magic",
    "Fruitifying learning",
    "Fruitifying",
    "Generating teaching magic",
    "Magic loading…",
    "Fruitifying your teaching",
  ],
  [MESSAGE_CATEGORIES.feedback]: [
    "Polishing feedback",
    "Organising your feedback",
  ],
  //  "GeneralLoading insights", // TODO: future
  //  "Finding learning opportunities…",
  //  "Highlighting learning opportunities…",
  //  "Uncovering learning opportunities…",
  //  "Generating learning opportunities…",
};
export const CATEGORIES = Object.keys(loadingMessages);

/**
 * Get a random loading message for a given category.
 * Throws an error if the category does not exist.
 */

export function getRandomMessage(category) {
  if (!CATEGORIES.includes(category)) {
    throw new Error(
      `Invalid category "${category}". Must be one of: ${CATEGORIES.join(
        ", ",
      )}`,
    );
  }

  const messages = loadingMessages[category];
  return messages[Math.floor(Math.random() * messages.length)];
}
